import { render, staticRenderFns } from "./AvailableDeskspace.vue?vue&type=template&id=41337477"
import script from "./AvailableDeskspace.vue?vue&type=script&lang=js"
export * from "./AvailableDeskspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports